module.exports = __webpack_public_path__ + "static/parade-2019-house07-8e39a0a2ba6cdfc3874d5300127106b4.jpg";